import { useNavigate, useLocation, Link } from 'react-router-dom'
import { Sparkles } from 'lucide-react'
import { LoginForm } from '@/components/auth'
import { Card, CardContent } from '@/components/ui'
import { useAuth } from '@/context/AuthContext'
import { useEffect } from 'react'

export function Login() {
  const navigate = useNavigate()
  const location = useLocation()
  const { user } = useAuth()

  // Get the page they were trying to visit
  const from = (location.state as { from?: { pathname: string } })?.from?.pathname || '/select-writer'

  // Redirect if already logged in
  useEffect(() => {
    if (user) {
      navigate(from, { replace: true })
    }
  }, [user, navigate, from])

  const handleSuccess = () => {
    navigate(from, { replace: true })
  }

  return (
    <div className="min-h-screen bg-[var(--color-kids-bg)] flex flex-col">
      {/* Header */}
      <header className="p-6">
        <Link to="/" className="flex items-center gap-3 w-fit">
          <Sparkles className="w-8 h-8 text-[var(--color-kids-primary)]" />
          <span className="font-display text-2xl font-bold text-[var(--color-kids-text)]">
            Inkwell Jr.
          </span>
        </Link>
      </header>

      {/* Main content */}
      <main className="flex-1 flex items-center justify-center p-6">
        <div className="w-full max-w-md">
          <div className="text-center mb-8">
            <h1 className="font-display text-[var(--font-size-kid-2xl)] font-bold text-[var(--color-kids-text)] mb-2">
              Welcome Back!
            </h1>
            <p className="text-[var(--color-kids-text-muted)]">
              Log in to continue your writing adventure
            </p>
          </div>

          <Card>
            <CardContent className="p-8">
              <LoginForm onSuccess={handleSuccess} />
            </CardContent>
          </Card>
        </div>
      </main>
    </div>
  )
}
